import { useEffect, useState } from 'react';
import { getListaStatusOperacao } from 'api/capitalFlow';
import { openSnackbarMain } from 'components/Shared/openSnackbarMain';

const useFiltrosTabelaHistoricoHook = ({ onFiltrar, presetFiltros }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [listaStatusOperacao, setListaStatusOperacao] = useState([]);
  const open = Boolean(anchorEl);
  const id = open ? 'filtros-popover' : undefined;

  const filtrosIniciais = {
    numero_operacao_one7: '',
    status_cessao: '',
    numero_documento: '',
    data_solicitacao_de: null,
    data_solicitacao_ate: null,
    valor_de: '',
    valor_ate: ''
  };

  const [filtros, setFiltros] = useState(filtrosIniciais);

  const handleOpen = e => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleChange = (campo, valor) => {
    setFiltros(prev => ({ ...prev, [campo]: valor }));
  };

  const toDateSafe = value => {
    if (!value) return null;
    if (value instanceof Date) return value;
    if (typeof value?.toDate === 'function') return value.toDate();
    return new Date(value);
  };

  const formatarDataParafiltro = dataParaFormatar => {
    const data = toDateSafe(dataParaFormatar);
    if (!data || Number.isNaN(data.getTime())) return null;
    return data.toLocaleDateString('pt-BR');
  };

  const formatarValor = valor => {
    if (!valor) return '';
    const valorNumerico = parseFloat(valor);
    if (Number.isNaN(valorNumerico)) return '';
    return valorNumerico / 100;
  };

  const handleFiltrar = () => {
    const filtrosFormatados = {
      ...filtros,
      valor_de: formatarValor(filtros.valor_de),
      valor_ate: formatarValor(filtros.valor_ate),
      ...(filtros.data_solicitacao_de != null && {
        data_solicitacao_de: formatarDataParafiltro(filtros.data_solicitacao_de)
      }),
      ...(filtros.data_solicitacao_ate != null && {
        data_solicitacao_ate: formatarDataParafiltro(filtros.data_solicitacao_ate)
      })
    };

    onFiltrar?.(filtrosFormatados);
    handleClose();
  };

  const handleLimpar = () => {
    setFiltros(filtrosIniciais);
    onFiltrar?.({ ...filtrosIniciais, filtro_origem: 'abas' }, { reset: true });
    handleClose();
  };

  const handleBuscarListaStatusOperacao = () => {
    getListaStatusOperacao()
      .then(response => {
        const { data } = response;
        setListaStatusOperacao(data);
      })
      .catch(() => {
        openSnackbarMain('Ocorreu um erro ao buscar os status da cessão', 'error');
      });
  };

  useEffect(() => {
    if (!presetFiltros) return;

    setFiltros({
      ...filtrosIniciais,
      ...presetFiltros
    });
  }, [presetFiltros]);

  useEffect(() => {
    handleBuscarListaStatusOperacao();
  }, []);

  return {
    id,
    open,
    filtros,
    anchorEl,
    handleOpen,
    handleClose,
    handleChange,
    handleLimpar,
    handleFiltrar,
    listaStatusOperacao
  };
};

export default useFiltrosTabelaHistoricoHook;
